import { defineStore } from "pinia";

const SESSION_KEY = "idk_disclaimer_accepted";

function getCookie(name) {
  const encodedName = encodeURIComponent(name);
  const parts = String(document.cookie || "").split("; ");
  for (const part of parts) {
    if (!part) continue;
    const [rawKey, ...rawValueParts] = part.split("=");
    if (rawKey !== encodedName) continue;
    return decodeURIComponent(rawValueParts.join("=") || "");
  }
  return "";
}

function setCookie(name, value, days = 365) {
  const encodedName = encodeURIComponent(name);
  const encodedValue = encodeURIComponent(String(value));
  const maxAge = Math.max(0, Math.floor(days * 24 * 60 * 60));
  document.cookie = `${encodedName}=${encodedValue}; path=/; max-age=${maxAge}; samesite=lax`;
}

function removeCookie(name) {
  const encodedName = encodeURIComponent(name);
  document.cookie = `${encodedName}=; path=/; max-age=0; samesite=lax`;
}

export const useDisclaimerStore = defineStore("disclaimer", {
  state: () => ({
    accepted: getCookie(SESSION_KEY) === "true",

    declined: false,
  }),

  actions: {
    accept() {
      this.accepted = true;

      this.declined = false;

      setCookie(SESSION_KEY, "true");
    },

    decline() {
      this.accepted = false;

      this.declined = true;

      removeCookie(SESSION_KEY);
    },

    reset() {
      this.declined = false;
    },
  },
});
